import { ParamsResponse } from 'interfaces/global.types';
import request from './request';

const policyService = {
  getAll: (params?: ParamsResponse) => request.get('policy/', { params }),
  getID: (id?: number) => request.get(`policy/${id}/`),
  delete: (id?: number) => request.delete(`policy/${id}/`),
  close: (id?: number, data?: any) => request.patch(`policy/${id}/`, data),
  create: (data?: any) => request.post('policy/', data),
  import: (data?: any) => request.post('import/', data),
  update: (id?: number, data?: any) => request.patch(`policy/${id}/`, data),
  export: (params?: ParamsResponse) => request.get('policy/export/', { params, responseType: 'blob' }),
};

export default policyService;
